const DEFAULT_MAX = 2000;
const DEFAULT_IDLE_MS = 1000;
/**
 * A buffer that hands its contents over once a frame.
 *
 * It exists so a socket delivering forty trades a second does not re-render
 * forty times. The part that needed fixing is what happens when the frames
 * stop: a background tab never gets one, and this used to wait for it
 * forever while `push` kept appending. A token page left open in another tab
 * grew to several gigabytes that way, on a machine whose fans said so.
 */
export function createRafBuffer(onFlush, { max = DEFAULT_MAX, idleMs = DEFAULT_IDLE_MS } = {}) {
    let frameId = null;
    let timerId = null;
    let buffer = [];
    const unschedule = () => {
        if (frameId !== null) {
            cancelAnimationFrame(frameId);
            frameId = null;
        }
        if (timerId !== null) {
            clearTimeout(timerId);
            timerId = null;
        }
    };
    const runFlush = () => {
        unschedule();
        if (buffer.length === 0) {
            return;
        }
        const items = buffer;
        buffer = [];
        onFlush(items);
    };
    const schedule = () => {
        if (frameId === null) {
            frameId = requestAnimationFrame(runFlush);
        }
        /* Armed alongside the frame, not instead of it: whichever arrives first
           flushes and cancels the other. In a visible tab that is always the
           frame, so the fast path is unchanged. */
        if (timerId === null) {
            timerId = setTimeout(runFlush, idleMs);
        }
    };
    return {
        push: (item) => {
            buffer.push(item);
            if (buffer.length > max) {
                buffer = buffer.slice(-max);
            }
            schedule();
        },
        flush: () => {
            runFlush();
        },
        cancel: () => {
            unschedule();
            buffer = [];
        },
        size: () => buffer.length,
    };
}
//# sourceMappingURL=RafBuffer.js.map